import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiClock, FiLock, FiLogIn } from 'react-icons/fi';
import { resolveSettingMediaUrl, useSiteSettings } from '../context/SiteSettingsContext';
import { useLocale } from '../context/LocaleContext';
import './SiteUnavailable.css';

export const MaintenancePage = () => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const { settings } = useSiteSettings();
  const logo = resolveSettingMediaUrl(settings.general.logoUrl);
  return (
    <main className="site-unavailable">
      <section className="site-unavailable-card">
        {logo && <img src={logo} alt={settings.general.siteTitle} />}
        <span className="site-unavailable-icon"><FiClock /></span>
        <h1>{settings.status.maintenanceTitle}</h1>
        <p>{settings.status.maintenanceMessage}</p>
        <div className="site-unavailable-contact">
          {settings.contact.supportEmail && <a href={`mailto:${settings.contact.supportEmail}`}>{settings.contact.supportEmail}</a>}
          <Link to={localePath('/login')}><FiLogIn /> {t('unavailable.adminLogin')}</Link>
        </div>
      </section>
    </main>
  );
};

export const RegistrationUnavailable = () => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const { settings } = useSiteSettings();
  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card site-registration-closed">
          <span><FiLock /></span>
          <h2>{t('unavailable.registrationTitle')}</h2>
          <p>{t('unavailable.registrationMessage', { site: settings.general.siteTitle })}</p>
          <Link to={localePath('/login')} className="auth-btn">{t('unavailable.existingLogin')}</Link>
          <Link to={localePath('/')} className="site-registration-home">{t('unavailable.home')}</Link>
        </div>
      </div>
    </div>
  );
};
